import { defineStore } from 'pinia';

export const useFeedStore = defineStore('feed', {
  state: () => ({
    homeFeed: [],
    madeForYou: [],
    indiaPlaylist: [],
    globalPlaylist: [],
    quickPicks:[]
  }),
  getters: {
    doubleCount: (state) => state.count * 2,
    isAuthenticated: (state) => !!state.user
  },
  actions: {
    async fetchMadeForYou(){
        try {
            const res = await fetch(`${process.env.VUE_APP_PROD_URL}/user/madeForYou`, { credentials: 'include' }).then((r) => r.json());
            this.madeForYou = res.data?.songs || [];
        } catch (error) {
            console.error(error);
        }
    },
    async fetchTopSongs(){
      try {
        const res = await fetch(`${process.env.VUE_APP_PROD_URL}/user/topTracks`, { credentials: 'include' });
        const data = await res.json();
        this.quickPicks = data.data.tracks;
      } catch (error) {
        console.error(error);
      }
    },
    setHomeFeed(feed){
      this.homeFeed = feed;
    },
    setIndiaPlaylist(feed){
      this.indiaPlaylist = feed;
    },
    setGlobalPlaylist(feed){
      this.globalPlaylist = feed;
    }
  }
});